var map = {
	"./centimeter.jpg": "3dc3",
	"./dots.jpg": "6061",
	"./lumi_accessories.jpg": "aced",
	"./marita_huurinainen.jpg": "a25f",
	"./pure_waste.jpg": "d615",
	"./tauko_design.jpg": "9c1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "29fa";